import { tokenReset } from './token.service'
import { api } from '@/src/shared/lib/api'
import { logoutPost } from '@/src/shared/api'

export async function logout(): Promise<void> {
  await logoutPost()
  tokenReset()
  api.tokenReset()
}
